import React, { useState, useEffect } from "react";
import instance from "../../services/ApiServices";
import { useDispatch } from "react-redux";
import { ChangeQuantity } from "../../stores/cart";

function CartItems(props) {
  const { productId, quantity } = props.data;
  const [detail, setDetail] = useState([]);
  const endpoint = `menuitems/${productId}`;
  const dispatch = useDispatch();

  const handleMinusQty = () => {
    dispatch(
      ChangeQuantity({
        productId: productId,
        quantity: quantity - 1,
      })
    );
  };

  const handlePlusQty = () => {
    dispatch(
      ChangeQuantity({
        productId: productId,
        quantity: quantity + 1,
      })
    );
  };

  useEffect(() => {
    // call Data from api
    instance.get(endpoint).then((res) => {
      const datas = res.data;
      setDetail(datas);
    });
  }, [endpoint]);

  // console.log(detail);
  return (
    <div className="text-white flex justify-between items-center p-2 border-b-2 gap-5 ">
      <p className="w-3/4">{detail.name}</p>
      <p className="w-1/4">${detail.price * quantity}</p>
      <div className="w-20 flex justify-between gap-2">
        <button
          onClick={handleMinusQty}
          className="bg-cyan-600 rounded-full w-6 h-6 text-white"
        >
          {" "}
          -{" "}
        </button>
        <span>{quantity}</span>
        <button
          onClick={handlePlusQty}
          className="bg-cyan-600 rounded-full w-6 h-6 text-white"
        >
          {" "}
          +{" "}
        </button>
      </div>
    </div>
  );
}

export default CartItems;
